// FP Directory utility functions

import type { FranchisePartner, FPStatus } from './types'

// Status color functions (matching admin panel)
export const getStatusColor = (status: FPStatus): 'success' | 'info' | 'error' | 'default' => {
  switch (status) {
    case 'Active':
      return 'success'
    case 'Onboarding':
      return 'info'
    case 'Terminated':
      return 'error'
    case 'Test':
    default:
      return 'default'
  }
}


export const getFranchiseeName = (fp: FranchisePartner): string => {
  const parts = [fp.franchisee_first_name, fp.franchisee_last_name].filter(Boolean)
  return parts.length > 0 ? parts.join(' ') : '-'
}
